var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"weui-btn",class:[
    'weui-btn_' + _vm.type,
    'weui-btn-size_' + _vm.size,
    {
      'weui-btn_disabled': _vm.disabled,
      'weui-btn_ghost': _vm.ghost,
    },
  ],attrs:{"href":"javascript:;","role":"button"},on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }